<template>
  <div id="imageWrapper">
    <div id="lightbox" onclick="getElementById('lightbox').style.display = 'none'">
      <div id="lightboxWrapper">
        <span id="largeImage">
          <div><span id="leftArrow"><</span></div>
          <img :src="'./static/images/fullres/'+imageNames[position]"/>
          <div><span id="rightArrow">></span></div>
        </span>
        <div id="imageTools">
          <span onclick="getElementById('lightbox').style.display = 'none'" id="close">X</span>
        </div>
      </div>
    </div>
    <h1 style="color: #F2AA4CFF">Pictures</h1>
    <!-- <img alt="Vue logo" src="../images/IMG_0275.JPG"> -->
    <!-- TODO: Fix loading / play animation after images have been loaded -->
    <div id="imageContainer">
      <img v-on:click="positionx = index;" v-for="(item, index) in imageNames" :key="item" style="cursor: pointer;" :src="'./static/images/thumbnails/'+item" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Pictures',
  data () {
    return {
      imageNames: ['tree.jpg', 'turtle.jpg', 'IMG_0132.jpg', 'IMG_0179.jpg', 'IMG_0322.jpg', 'IMG_0511.jpg', 'IMG_0552.jpg', 'IMG_0568.jpg', 'IMG_0584.jpg', 'IMG_0607.jpg', 'IMG_1888.jpg', 'IMG_1900.jpg', 'IMG_2008.jpg', 'IMG_2015.jpg', 'IMG_2063.jpg'],
      position: 0
    }
  },
  computed: {
    positionx: {
      set: function (newValue) {
        document.getElementById('lightbox').style.display = 'flex'
        document.getElementById('imageWrapper').style.overflow = 'hidden'
        this.position = newValue
      },
      get: function () {
        return this.position
      }
    }
  },
  mounted () {
    const container = document.getElementById('imageContainer')
    container.style.opacity = '1'
  }
}
</script>
<style lang="scss">
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  body {
    color: #F2AA4CFF;
    background-color: #101820FF;
  }
  #lightbox {
    display: flex;
    cursor: pointer;
    position: fixed;
    display: none;
    flex-direction: column;
    z-index: 998;
    top:0;
    left:0;
    box-sizing:border-box;
    width: 100%;
    height: 100%;
    padding: 1em;
    background-color: #101820CC;
    #lightboxWrapper {
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin: 0 auto;
      max-width: 1100px;
      width: 100%;
      height: 100vh;
      #imageTools {
        display: flex;
        justify-content: center;
        #close {
          color: white;
          padding: 5px 15px;
          font-size: 20pt;
          background-color: rgba(255, 0, 0, 0.3);
          &:hover {
            background-color: rgba(255, 0, 0, 0.8);
          }
        }
      }
      #largeImage {
        display: flex;
        img {
          width: 80%;
          flex-grow: 2;
        }
        div {
          flex-grow: 1;
          font-size: 24pt;
          background-color: rgba(255, 255, 255, 0.027);
          display: flex;
          transition-duration: 0.3s;
          &:hover {
            background-color: rgba(255, 255, 255, 0.227);
          }
          &:hover > #leftArrow {
            transform: translateX(-10px);
          }
          &:hover > #rightArrow {
            transform: translateX(10px);
          }
          span {
            transition-duration: 0.3s;
            align-self: center;
            width: 100%;
            color: white;
          }
        }
      }
    }
  }
  #imageContainer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin: 0px auto;
    max-width:1600px;
    gap: 0.5em;
    padding: 0.5em;
    img {
      max-width: 800px;
      width: 100%;
    }
  }
  @media (max-width: 1280px) {
    #imageContainer {
      grid-template-columns: 1fr 1fr;
    }
  }
  @media (max-width: 640px) {
    #imageContainer {
      grid-template-columns: 1fr;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Pictures.vue